<template>
  <div>
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- DIALOG PRINCIPAL: LISTA -->
    <v-dialog
      max-width="75%"
      v-model="dialogList"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon left>mdi-server-network</v-icon>
          Administrar Servidores de Descarga
          <v-spacer></v-spacer>

          <v-btn icon :disabled="loading" @click="getItems">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>

          <v-btn icon @click="closeList">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :items="items"
            :headers="headers"
            :loading="loading"
            item-key="id_factura_servidor"
          >
            <template v-slot:[`item.autorizado`]="{ item }">
              <v-chip small :color="toBool(item.autorizado) ? 'green' : 'grey'" text-color="white">
                {{ toBool(item.autorizado) ? "Autorizado" : "No autorizado" }}
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="openDialogEdit(item)">
                mdi-pencil
              </v-icon>
            </template>

            <template v-slot:no-data>
              <v-alert type="info" text dense>
                No hay servidores registrados todavía.
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeList">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG EDICIÓN (como tu ejemplo) -->
    <v-dialog
      max-width="55%"
      v-model="dialogEdit"
      persistent
    >
      <v-card>
        <v-card-title>
          Editar Servidor
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="editedItem.autorizar"
                inset
                dense
                hide-details
                :label="editedItem.autorizar ? 'Autorizado' : 'No autorizado'"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogEdit" :loading="loadingSave">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";

export default {
  name: "FacturaServidoresDialog",
  components: { VAlertDialog },
  data: () => ({
    dialogList: false,
    dialogEdit: false,

    loading: false,
    loadingSave: false,

    items: [],
    headers: [
      { text: "Nombre", value: "nombre", align: "start", width: "65%" },
      { text: "Autorización", value: "autorizado", align: "center", width: "25%" },
      { text: "Acciones", value: "actions", align: "center", width: "10%" }
    ],

    editedItem: {
      id_factura_servidor: null,
      nombre: "",
      autorizar: false
    },
    defaultEditedItem: {
      id_factura_servidor: null,
      nombre: "",
      autorizar: false
    }
  }),
  methods: {
    // 👇 Pública: la llamas desde el padre con ref
    open() {
      this.dialogList = true;
      this.getItems();
    },

    closeList() {
      this.dialogList = false;
    },

    getItems() {
      this.loading = true;

      axios
        .get("/Pagos/ListarFacturaServidores")
        .then(resp => {
          this.items = resp.data || [];
        })
        .catch(err => {
          console.log(err);
          this.$refs.alert.setMessage("", "Error al listar servidores.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogEdit(item) {
      this.editedItem = Object.assign({}, this.defaultEditedItem, {
        id_factura_servidor: item.id_factura_servidor,
        nombre: item.nombre || "",
        autorizar: this.toBool(item.autorizado)
      });

      this.dialogEdit = true;
    },

    closeDialogEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogEdit = false;
    },

    saveDialogEdit() {
      const nombre = (this.editedItem.nombre || "").trim();

      if (!nombre || nombre.length > 256) {
        this.$refs.alert.setMessage("", "Debe de ingresar un Nombre entre 1 y 256 caracteres");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      axios
        .post("/Pagos/ActualizarFacturaServidor", {
          id_factura_servidor: this.editedItem.id_factura_servidor,
          nombre: nombre,
          autorizar: !!this.editedItem.autorizar
        })
        .then(() => {
          this.closeDialogEdit();
          this.getItems(); // refresca lista
        })
        .catch(err => {
          console.log(err);
          this.$refs.alert.setMessage("", "Error al actualizar el servidor.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    toBool(autorizado) {
      // Tu API manda string. Ajusta aquí si tienes un formato fijo.
      if (autorizado === null || autorizado === undefined) return false;
      const s = String(autorizado).trim().toLowerCase();
      if (!s) return false;

      if (["true", "1", "si", "sí", "autorizado", "yes"].includes(s)) return true;
      if (["false", "0", "no", "no autorizado"].includes(s)) return false;

      // si viene una fecha u otro string no vacío => true
      return true;
    }
  }
};
</script>